import * as o from "react";
import r from "../lib/IconBase.es.js";
import n from "../defs/NoteBlank.es.js";
const e = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(r, { ref: a, ...t, weights: n }));
e.displayName = "NoteBlankIcon";
const s = e;
export {
  s as NoteBlank,
  e as NoteBlankIcon
};
